
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11751',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11751",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.282",
  "data-fetching-client": "static-1.9540",
  "foundations-components": "static-1.7641",
  "foundations-components-legacy": "static-1.666",
  "foundations-theming": "static-1.4274",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7870",
  "hub-http-shared-msw-handlers": "static-1.9631",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11306",
  "I18n": "static-7.1592",
  "jasmine-runner": "static-1.6333",
  "marketplace-storefront-base": "static-1.11811",
  "quartz": "static-1.6814",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16513",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2726",
  "reporting-testing-lib": "static-1.8716",
  "settings-ui-lib": "static-1.12386",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6859",
  "ui-addon-i18n": "static-1.11008",
  "ui-addon-react-router-dom": "static-1.9408",
  "unified-auth": "static-1.299",
  "unified-auth-core-lib": "static-1.580",
  "usage-tracker": "static-1.7198",
  "usage-tracker-core": "static-1.7048",
  "customer-data-property-utils": "static-1.7943",
  "history": "static-4.47",
  "hub-http": "static-1.6080",
  "integrations-lib": "static-1.15622",
  "marketplace-ui-common": "static-1.19129",
  "property-management-iframe": "static-1.12613",
  "quartz-config": "static-1.592",
  "quartz-core": "static-1.6033",
  "quartz-routing": "static-1.244",
  "quick-fetch": "static-1.3797",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4505",
  "ts-schema": "static-1.3964",
  "ui-universal-auth": "static-1.8785",
  "UIComponents": "static-3.8253",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3289",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3091",
  "quartz-webpack": "static-1.3038",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3910",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4704",
  "foundations-theming-specialty": "static-1.1990",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9289",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5234",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1382",
  "ui-fonts": "static-1.568",
  "ui-images": "static-2.1117",
  "bend-plugin-foundations-theming": "static-1.2757",
  "foundations-theming-base": "static-1.3259",
  "stylex": "static-1.28",
  "HeadJS": "static-2.727",
  "hs-test-utils-bend-plugin": "static-1.2981",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4189",
  "ai-components-ui-library": "static-1.8539",
  "ai-rendering-library": "static-1.9505",
  "chirp-fetch": "static-1.1746",
  "connections-embed-lib": "static-1.725",
  "copilot-toolkit": "static-1.10698",
  "laboratory-lib": "static-3.7022",
  "marketplace-embed": "static-1.21641",
  "marketplace-ui-details": "static-1.9025",
  "marketplace-ui-reviews": "static-1.19085",
  "marketplace-ui-tracking": "static-1.13300",
  "sanitize-text": "static-1.8008",
  "ui-addon-video-player": "static-1.8559",
  "usage-tracker-multi": "static-1.5612",
  "usage-tracker-session-replay": "static-1.4884",
  "wootric-nps": "static-1.6845",
  "apollo-link-hub-http": "static-2.4514",
  "immer": "static-1.33",
  "immerable": "static-1.4017",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2407",
  "reporting-data": "static-1.66783",
  "cssUtils": "static-1.757",
  "flux-actions": "static-1.320",
  "HubStyle": "static-2.11614",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10074",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10237",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7188",
  "icons": "static-2.634",
  "marketplace-ui-apps-core": "static-1.17662",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4383",
  "foundations-components-test-utils": "static-1.5124",
  "quartz-i18n": "static-1.489",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3593",
  "customer-data-objects": "static-1.7515",
  "property-translator": "static-1.5272",
  "frontend-preferences-client": "static-1.7787",
  "hs-promise-utils": "static-1.5456",
  "hubspot-apollo-client": "static-1.4742",
  "integrations-error-boundary-lib": "static-1.13037",
  "integrations-tracking-lib": "static-1.5453",
  "native-integrations-shared-strings": "static-1.7650",
  "reselect": "static-2.16",
  "sanitize": "static-1.4337",
  "superstore": "static-1.4632",
  "ui-shepherd-react": "static-3.10009",
  "ai-settings-ui-library": "static-1.7645",
  "hub-http-janus": "static-1.812",
  "hubspotter-http": "static-1.4537",
  "immutable-less": "static-1.4517",
  "marketplace-ui-client-types": "static-1.16536",
  "nav-meta": "static-1.29116",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10105",
  "ui-addon-upgrades": "static-9.17750",
  "inbound-db-properties-service-client": "static-1.3730",
  "property-management-common": "static-1.4900",
  "ui-addon-iframeable": "static-1.8910",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.502",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.489",
  "quartz-head": "static-1.479",
  "quartz-test": "static-1.489",
  "quartz-tracking": "static-1.193",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3018",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20600",
  "ContentUtils": "static-1.67814",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2355",
  "customer-data-filters-ui": "static-1.39129",
  "customer-data-objects-ui-components": "static-1.12875",
  "customer-data-reference-ui-components": "static-1.13011",
  "embedded-academy-lib": "static-1.13777",
  "ExportDialog": "static-6.10251",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40822",
  "reporting-snowflake": "static-1.55401",
  "reporting-ui-components": "static-2.64054",
  "reporting-visualizations": "static-1.58859",
  "ui-addon-teams": "static-1.21330",
  "magpie-lib": "static-1.5457",
  "magpie-types": "static-1.4917",
  "simple-logging-lib": "static-1.2913",
  "navigation-components": "static-1.17479",
  "ai-studio-lib": "static-1.11170",
  "app-governance-lib": "static-1.1072",
  "developer-experience-shared-components": "static-1.10364",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7854",
  "ui-product-approvals": "static-1.27647",
  "ui-tool-access": "static-1.10008",
  "usage-based-billing-components-lib": "static-1.8184",
  "usage-tracker-anonymous": "static-1.5615",
  "usage-tracker-public": "static-1.7009",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3479",
  "persist-promise": "static-1.3571",
  "reference-resolvers": "static-1.8027",
  "ui-extensibility-client-types": "static-1.3804",
  "hubspot-apollo-cache": "static-1.201",
  "universal-page-editor-lib": "static-1.2864",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2353",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4933",
  "purchase-motions-components": "static-1.5579",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1414",
  "crm-component-utils": "static-1.38636",
  "crm-properties-common-lib": "static-1.5736",
  "customer-data-properties": "static-1.50983",
  "framework-data-schema-resolvers": "static-1.6736",
  "property-value-citations": "static-1.1597",
  "reference-resolvers-lite": "static-1.7948",
  "navigation-messaging": "static-1.6806",
  "hubspotter-http-shared-msw-handlers": "static-1.9629",
  "cms-field-types": "static-1.4672",
  "content-icons-ui": "static-1.2181",
  "conversations-skeleton-state": "static-1.7112",
  "crm-message-bus": "static-1.42555",
  "customer-data-filters-ui-msw-helpers": "static-1.21564",
  "customer-data-ui-utilities": "static-1.9687",
  "FormUrlGenerator": "static-2.4584",
  "framework-builder-read-service-client": "static-1.3892",
  "framework-data-schema-quick-fetch": "static-1.6641",
  "multi-account-reference-resolvers": "static-1.839",
  "onboarding-tours": "static-1.16349",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13238",
  "academy-common-lib": "static-1.13237",
  "content-assistance-lib": "static-1.7536",
  "dashboard-lib": "static-1.80885",
  "file-manager-components": "static-1.23106",
  "getting-started-shared-tasks": "static-1.18056",
  "hubspot-prosemirror": "static-1.17785",
  "hubspot-prosemirror-plugins": "static-1.17777",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19582",
  "share-with-third-party-component-lib": "static-1.8556",
  "ui-addon-draggable": "static-3.4631",
  "ui-asset-management-lib": "static-1.10798",
  "ui-business-units-lib": "static-1.8895",
  "user-context": "static-1.4963",
  "growth-payments-core": "static-1.24904",
  "reporting-plugins": "static-1.10057",
  "reporting-reports": "static-1.66461",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.588",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28996",
  "react-codemirror": "static-1.10489",
  "framework-listing-lib": "static-2.28210",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30269",
  "apps-service-types": "static-1.3740",
  "oauth-service-types": "static-1.4110",
  "onboarding-scopes": "static-1.6326",
  "onboarding-tours-client": "static-1.4563",
  "platform-infra-nav-components": "static-1.7551",
  "subscription-experience-data-types": "static-1.14667",
  "crm-record-cards-service-types": "static-1.3501",
  "location-customization-utils-lib": "static-1.8760",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4362",
  "nav-client-types": "static-1.2220",
  "purchase-motions-api": "static-1.5582",
  "signup-constants": "static-1.18525",
  "signup-ui-url-generator": "static-2.7898",
  "trials-service-types": "static-1.3763",
  "card-properties-lib": "static-1.43704",
  "commerce-subscription-lib": "static-1.36638",
  "crm-actions": "static-1.6172",
  "crm-cards-sdk": "static-1.43105",
  "customer-data-properties-shared-msw-handlers": "static-1.8958",
  "customer-data-tracking": "static-1.6745",
  "hs-entities": "static-1.550",
  "pulse": "static-1.387",
  "calling-global-api": "static-1.63920",
  "calling-internal-common": "static-1.31163",
  "calling-lifecycle-internal": "static-1.65302",
  "calling-lifecycle-messages": "static-1.57596",
  "commerce-products-lib": "static-1.9022",
  "conditional-properties-service-client": "static-1.3682",
  "crm-links": "static-1.6132",
  "external-options-client-types": "static-1.4043",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4107",
  "meetings-icalendar-utils-lib": "static-1.495",
  "multi-currency-client-types": "static-1.3574",
  "object-builder-ui-client": "static-1.48205",
  "pipeline-validation-client-types": "static-1.3848",
  "smart-property-lib": "static-1.6174",
  "tiered-pricing": "static-1.927",
  "ui-addon-form-validation": "static-1.10856",
  "crm-pipelines-api-client-types": "static-1.4024",
  "react-dnd-compat": "static-1.4483",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5222",
  "growth-onboarding-confetti": "static-1.2935",
  "growth-onboarding-next-action-utils": "static-1.1462",
  "onboarding-tours-utils": "static-1.415",
  "ui-shepherd-tracker": "static-1.7390",
  "academy-service-client": "static-1.3543",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28110",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8246",
  "video-components-external": "static-1.10771",
  "video-data-lib": "static-1.34429",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8421",
  "payment-link-components": "static-1.23104",
  "ui-addon-emoji-picker": "static-1.9750",
  "EmailSignatureEditor": "static-1.24023",
  "viral-links-lib": "static-1.6903",
  "data-token-picker": "static-1.16154",
  "FileManagerLib": "static-1.38746",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5107",
  "getting-started-shared-tasks-store": "static-1.17174",
  "campaign-roi-lib": "static-1.8468",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7185",
  "customer-data-views-management": "static-1.25115",
  "framework-data-table": "static-2.11569",
  "marketing-platform-lib": "static-1.6707",
  "nudge-client-utils": "static-1.2280",
  "nudge-custom-ui-functions": "static-1.785",
  "app-users-service-client": "static-1.5407",
  "app-users-service-types": "static-1.4815",
  "mini-checkout-client": "static-1.26473",
  "onboarding-utils": "static-1.5215",
  "permissions-shared-i18n-strings-fe": "static-1.1975",
  "ui-coaching-tips-shared-config": "static-1.28095",
  "edison-service-client-types": "static-1.255",
  "eligibility-engine-service-types": "static-1.3044",
  "crm_data": "static-4.91455",
  "customer-data-sidebar": "static-2.45584",
  "enrichment-properties-lib": "static-1.15292",
  "commerce-billing-lib": "static-1.18664",
  "commerce-shared-components-lib": "static-1.18123",
  "commerce-tools-ui-lib": "static-1.9958",
  "crm-fe-perf": "static-1.22767",
  "directed-graph": "static-1.802",
  "event-emitter": "static-1.810",
  "fast-json-patch": "static-1.59",
  "calling-error-reporting": "static-1.31169",
  "shared-worker-versioning": "static-1.10902",
  "calling-usage-tracker": "static-1.6404",
  "voice-sms-access-library": "static-1.429",
  "commerce-permissions": "static-1.626",
  "products-iframe-lib": "static-1.7506",
  "products-ui-components-shared-msw-handlers": "static-1.10013",
  "breeze-intelligence-kit": "static-1.5410",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9714",
  "policy-lib": "static-1.6641",
  "react-tinymce": "static-1.54799",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9777",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53925",
  "tinymce-plugins": "static-1.57039",
  "tinymce-themes": "static-1.55895",
  "growth-onboarding-next-action-components": "static-1.1490",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6444",
  "content-media-composition-data-lib": "static-1.11704",
  "content-media-compositions": "static-2.15711",
  "media-bridge-lib": "static-1.18676",
  "commerce-tours-lib": "static-1.5817",
  "growth-onboarding-reliability": "static-1.4949",
  "sales-checkout-service-client": "static-1.3531",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21420",
  "sales-email-signature-service-client": "static-1.3706",
  "audio-components": "static-1.5700",
  "FileManagerCore": "static-1.38605",
  "FileManagerImages": "static-1.36257",
  "video-components": "static-1.12774",
  "crm-export-dialog": "static-1.6156",
  "crm-index-associations-lib": "static-1.6298",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1486",
  "tanstack-virtual": "static-1.26",
  "nudge-custom-function-registry": "static-1.2037",
  "nudge-renderer-utils": "static-1.2356",
  "whisper-core-api": "static-1.6160",
  "InboxConnectUtils": "static-4.14388",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5206",
  "settings-content-modals": "static-1.45640",
  "crm_universal": "static-1.21756",
  "customer-data-email": "static-1.17781",
  "card-payment-highlight-lib": "static-1.36691",
  "card-subscription-highlight-lib": "static-1.39061",
  "commerce-contract-lib": "static-1.11431",
  "customer-data-content": "static-1.26994",
  "invoices-highlight-card-lib": "static-1.54228",
  "orders-highlight-card-lib": "static-1.21032",
  "products-highlight-card-lib": "static-1.17306",
  "project-storage": "static-1.4596",
  "quotes-highlight-card-lib": "static-1.71403",
  "crm-source-interpretation-lib": "static-1.5194",
  "utility-belt": "static-1.2403",
  "payments-enrollment-embed-lib": "static-1.22187",
  "customer-data-rte": "static-1.32600",
  "cv-backend-services": "static-1.1525",
  "growth-onboarding-empty-states": "static-1.5457",
  "payments-post-enroll-local-storage-lib": "static-1.4977",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37493",
  "calling-orchestration-schema": "static-1.35206",
  "sales-views-client-types": "static-1.4135",
  "hub-http-contrib": "static-1.2906",
  "interframe": "static-3.4625",
  "tinymce-data": "static-1.40010",
  "ui-addon-sales-email": "static-1.5076",
  "layout-dnd-components": "static-1.12163",
  "layout-dnd-utils": "static-1.11138",
  "ui-brand-identity-lib": "static-1.14336",
  "NamespacedHubStyle": "static-2.8954",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4394",
  "video-embed": "static-1.35263",
  "social-insights-client-types": "static-1.21568",
  "deal-intel-utils": "static-1.1490",
  "checkout-sdk": "static-3.23316",
  "checkout-service-types": "static-1.3715",
  "company-details-components": "static-1.6048",
  "payment-method-components": "static-1.6755",
  "pricing-pages-ui-components": "static-1.12959",
  "quote-checkout-service-types": "static-1.3349",
  "upgrade-catalog-service-types": "static-1.3389",
  "access-control-lib": "static-1.10301",
  "EmailComponents": "static-1.54316",
  "EmailData": "static-1.52993",
  "redux-less": "static-2.9349",
  "sequences-lib": "static-1.7794",
  "ui-gdpr-components": "static-1.10211",
  "products-ui-components": "static-1.39541",
  "quotes-ui-lib": "static-1.80124",
  "SalesContentIndexUI": "static-3.9000",
  "accounting-integrations-ui-components": "static-1.6830",
  "invoices-ui-lib": "static-1.54244",
  "commerce-products-api": "static-1.2052",
  "SafeStorage": "static-1.4265",
  "invoices-iframe-lib": "static-1.56302",
  "quotes-modal-lib": "static-1.102081",
  "stripe-embedded-components": "static-1.7250",
  "draft-content-plugins": "static-1.27868",
  "ContentData": "static-1.67889",
  "layout-data-lib": "static-1.9463",
  "outpost": "static-1.4062",
  "hub-http-rxjs": "static-1.778",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3792",
  "billing-payments-client-types": "static-1.3852",
  "account-and-billing-fintech-outages": "static-3.18321",
  "pricing-pages-api": "static-1.12824",
  "ContentComponents": "static-2.70770",
  "marketing-contacts-lib": "static-1.9336",
  "marketing-email-service-types": "static-1.1812",
  "messaging-editing-lib": "static-1.45799",
  "messaging-usage-based-billing-components-lib": "static-1.661",
  "automation-ui-source-apps": "static-1.18403",
  "automation-ui-types": "static-1.19321",
  "messaging-types-lib": "static-1.45536",
  "onboarding-settings-client": "static-1.4368",
  "sequences-client-types-lib": "static-1.7651",
  "commerce-tax-lib": "static-1.381",
  "property-description-translator": "static-1.3718",
  "FireAlarmUi": "static-1.4392",
  "sales-templates-service-types-lib": "static-1.4051",
  "commerce-analytics-service-client": "static-1.3519",
  "totals-ui-components": "static-1.23156",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14906",
  "advanced-menus-lib": "static-1.11874",
  "ui-memberships-settings-lib": "static-1.33617",
  "demographics-service-types": "static-1.1512",
  "automation-ui-ubb": "static-1.5237",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7203",
  "data-token-views": "static-1.16135",
  "forms-utils-lib": "static-1.12293",
  "payments-embed-points-lib": "static-1.12727",
  "simple-menus-core": "static-1.14905",
  "simple-menus-lib": "static-1.16422",
  "ui-addon-draggable-compat": "static-2.4117",
  "videoconference-integration-components": "static-1.6617",
  "automation-applications-service-types": "static-1.3396",
  "automation-platform-service-types": "static-1.2543",
  "ContentEditorUI": "static-2.76704",
  "short-messages-app-service-client": "static-1.3867",
  "web-interactives-components": "static-1.13511",
  "web-interactives-data": "static-1.13512",
  "messaging-shared-utils-lib": "static-1.110",
  "messaging-user-info-utils-lib": "static-1.280",
  "email-portal-health-service-types": "static-1.839",
  "commerce-totals-service-types": "static-1.3700",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21257",
  "automation-ui-usage-tracking": "static-1.20720",
  "data-studio-ubb": "static-1.2282",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26590",
  "collaboration-sidebar": "static-1.57300",
  "content-management-data-lib": "static-1.5192",
  "copilot-plugins": "static-1.10671",
  "cta-picker": "static-1.36000",
  "customer-agent-discovery-components-lib": "static-1.2617",
  "editor-components": "static-1.13023",
  "editor-iframe-lib": "static-1.8204",
  "error-messaging-js": "static-1.5053",
  "FormsCommonComponents": "static-1.85445",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.61",
  "redux-request-state": "static-1.10509",
  "SharedLegalStrings": "static-1.1614",
  "smart-content-core": "static-1.42022",
  "smart-content-lib": "static-1.42675",
  "social-composer-lib": "static-1.58391",
  "structured-content-lib": "static-1.24781",
  "theme-previewer-lib": "static-1.52850",
  "tinymce-copilot": "static-1.15993",
  "xray-recommendation-lib": "static-1.7678",
  "automation-ui-routing": "static-1.20678",
  "sql-reporting-client-types": "static-1.5529",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41809",
  "campaigns-utils-lib": "static-1.3018",
  "reporting-enablement": "static-1.22306",
  "chatspot-widget-iframe": "static-1.20592",
  "collaboration-sidebar-common": "static-1.2097",
  "forms-ai-lib": "static-1.4096",
  "codemirror-dlb": "static-1.58263",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6290",
  "report-customization-components": "static-1.12695",
  "data-quality-ui-library": "static-1.12478",
  "html-to-image": "static-1.50",
  "reporting-insights-lib": "static-1.1253"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11751",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.282",
  "data-fetching-client": "/data-fetching-client/static-1.9540",
  "foundations-components": "/foundations-components/static-1.7641",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.666",
  "foundations-theming": "/foundations-theming/static-1.4274",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7870",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9631",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11306",
  "I18n": "/I18n/static-7.1592",
  "jasmine-runner": "/jasmine-runner/static-1.6333",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11811",
  "quartz": "/quartz/static-1.6814",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16513",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2726",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8716",
  "settings-ui-lib": "/settings-ui-lib/static-1.12386",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6859",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11008",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9408",
  "unified-auth": "/unified-auth/static-1.299",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.580",
  "usage-tracker": "/usage-tracker/static-1.7198",
  "usage-tracker-core": "/usage-tracker-core/static-1.7048",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7943",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6080",
  "integrations-lib": "/integrations-lib/static-1.15622",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19129",
  "property-management-iframe": "/property-management-iframe/static-1.12613",
  "quartz-config": "/quartz-config/static-1.592",
  "quartz-core": "/quartz-core/static-1.6033",
  "quartz-routing": "/quartz-routing/static-1.244",
  "quick-fetch": "/quick-fetch/static-1.3797",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4505",
  "ts-schema": "/ts-schema/static-1.3964",
  "ui-universal-auth": "/ui-universal-auth/static-1.8785",
  "UIComponents": "/UIComponents/static-3.8253",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3289",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3091",
  "quartz-webpack": "/quartz-webpack/static-1.3038",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3910",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4704",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1990",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9289",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5234",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1382",
  "ui-fonts": "/ui-fonts/static-1.568",
  "ui-images": "/ui-images/static-2.1117",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2757",
  "foundations-theming-base": "/foundations-theming-base/static-1.3259",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.727",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2981",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4189",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8539",
  "ai-rendering-library": "/ai-rendering-library/static-1.9505",
  "chirp-fetch": "/chirp-fetch/static-1.1746",
  "connections-embed-lib": "/connections-embed-lib/static-1.725",
  "copilot-toolkit": "/copilot-toolkit/static-1.10698",
  "laboratory-lib": "/laboratory-lib/static-3.7022",
  "marketplace-embed": "/marketplace-embed/static-1.21641",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9025",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19085",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13300",
  "sanitize-text": "/sanitize-text/static-1.8008",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8559",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5612",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4884",
  "wootric-nps": "/wootric-nps/static-1.6845",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4514",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4017",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2407",
  "reporting-data": "/reporting-data/static-1.66783",
  "cssUtils": "/cssUtils/static-1.757",
  "flux-actions": "/flux-actions/static-1.320",
  "HubStyle": "/HubStyle/static-2.11614",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10074",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10237",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7188",
  "icons": "/icons/static-2.634",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17662",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4383",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5124",
  "quartz-i18n": "/quartz-i18n/static-1.489",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3593",
  "customer-data-objects": "/customer-data-objects/static-1.7515",
  "property-translator": "/property-translator/static-1.5272",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7787",
  "hs-promise-utils": "/hs-promise-utils/static-1.5456",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4742",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13037",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5453",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7650",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4337",
  "superstore": "/superstore/static-1.4632",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10009",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7645",
  "hub-http-janus": "/hub-http-janus/static-1.812",
  "hubspotter-http": "/hubspotter-http/static-1.4537",
  "immutable-less": "/immutable-less/static-1.4517",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16536",
  "nav-meta": "/nav-meta/static-1.29116",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10105",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17750",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3730",
  "property-management-common": "/property-management-common/static-1.4900",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8910",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.502",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.489",
  "quartz-head": "/quartz-head/static-1.479",
  "quartz-test": "/quartz-test/static-1.489",
  "quartz-tracking": "/quartz-tracking/static-1.193",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3018",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20600",
  "ContentUtils": "/ContentUtils/static-1.67814",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2355",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39129",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12875",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13011",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13777",
  "ExportDialog": "/ExportDialog/static-6.10251",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40822",
  "reporting-snowflake": "/reporting-snowflake/static-1.55401",
  "reporting-ui-components": "/reporting-ui-components/static-2.64054",
  "reporting-visualizations": "/reporting-visualizations/static-1.58859",
  "ui-addon-teams": "/ui-addon-teams/static-1.21330",
  "magpie-lib": "/magpie-lib/static-1.5457",
  "magpie-types": "/magpie-types/static-1.4917",
  "simple-logging-lib": "/simple-logging-lib/static-1.2913",
  "navigation-components": "/navigation-components/static-1.17479",
  "ai-studio-lib": "/ai-studio-lib/static-1.11170",
  "app-governance-lib": "/app-governance-lib/static-1.1072",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10364",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7854",
  "ui-product-approvals": "/ui-product-approvals/static-1.27647",
  "ui-tool-access": "/ui-tool-access/static-1.10008",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8184",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5615",
  "usage-tracker-public": "/usage-tracker-public/static-1.7009",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3479",
  "persist-promise": "/persist-promise/static-1.3571",
  "reference-resolvers": "/reference-resolvers/static-1.8027",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3804",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.201",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2864",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2353",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4933",
  "purchase-motions-components": "/purchase-motions-components/static-1.5579",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1414",
  "crm-component-utils": "/crm-component-utils/static-1.38636",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5736",
  "customer-data-properties": "/customer-data-properties/static-1.50983",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6736",
  "property-value-citations": "/property-value-citations/static-1.1597",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7948",
  "navigation-messaging": "/navigation-messaging/static-1.6806",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9629",
  "cms-field-types": "/cms-field-types/static-1.4672",
  "content-icons-ui": "/content-icons-ui/static-1.2181",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7112",
  "crm-message-bus": "/crm-message-bus/static-1.42555",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21564",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9687",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4584",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3892",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6641",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.839",
  "onboarding-tours": "/onboarding-tours/static-1.16349",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13238",
  "academy-common-lib": "/academy-common-lib/static-1.13237",
  "content-assistance-lib": "/content-assistance-lib/static-1.7536",
  "dashboard-lib": "/dashboard-lib/static-1.80885",
  "file-manager-components": "/file-manager-components/static-1.23106",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18056",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17785",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17777",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19582",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8556",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4631",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10798",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8895",
  "user-context": "/user-context/static-1.4963",
  "growth-payments-core": "/growth-payments-core/static-1.24904",
  "reporting-plugins": "/reporting-plugins/static-1.10057",
  "reporting-reports": "/reporting-reports/static-1.66461",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.588",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28996",
  "react-codemirror": "/react-codemirror/static-1.10489",
  "framework-listing-lib": "/framework-listing-lib/static-2.28210",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30269",
  "apps-service-types": "/apps-service-types/static-1.3740",
  "oauth-service-types": "/oauth-service-types/static-1.4110",
  "onboarding-scopes": "/onboarding-scopes/static-1.6326",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4563",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7551",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14667",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3501",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8760",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4362",
  "nav-client-types": "/nav-client-types/static-1.2220",
  "purchase-motions-api": "/purchase-motions-api/static-1.5582",
  "signup-constants": "/signup-constants/static-1.18525",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7898",
  "trials-service-types": "/trials-service-types/static-1.3763",
  "card-properties-lib": "/card-properties-lib/static-1.43704",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36638",
  "crm-actions": "/crm-actions/static-1.6172",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43105",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8958",
  "customer-data-tracking": "/customer-data-tracking/static-1.6745",
  "hs-entities": "/hs-entities/static-1.550",
  "pulse": "/pulse/static-1.387",
  "calling-global-api": "/calling-global-api/static-1.63920",
  "calling-internal-common": "/calling-internal-common/static-1.31163",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65302",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57596",
  "commerce-products-lib": "/commerce-products-lib/static-1.9022",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3682",
  "crm-links": "/crm-links/static-1.6132",
  "external-options-client-types": "/external-options-client-types/static-1.4043",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4107",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.495",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3574",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48205",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3848",
  "smart-property-lib": "/smart-property-lib/static-1.6174",
  "tiered-pricing": "/tiered-pricing/static-1.927",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10856",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4024",
  "react-dnd-compat": "/react-dnd-compat/static-1.4483",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5222",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2935",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1462",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.415",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7390",
  "academy-service-client": "/academy-service-client/static-1.3543",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28110",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8246",
  "video-components-external": "/video-components-external/static-1.10771",
  "video-data-lib": "/video-data-lib/static-1.34429",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8421",
  "payment-link-components": "/payment-link-components/static-1.23104",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9750",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24023",
  "viral-links-lib": "/viral-links-lib/static-1.6903",
  "data-token-picker": "/data-token-picker/static-1.16154",
  "FileManagerLib": "/FileManagerLib/static-1.38746",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5107",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17174",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8468",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7185",
  "customer-data-views-management": "/customer-data-views-management/static-1.25115",
  "framework-data-table": "/framework-data-table/static-2.11569",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6707",
  "nudge-client-utils": "/nudge-client-utils/static-1.2280",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.785",
  "app-users-service-client": "/app-users-service-client/static-1.5407",
  "app-users-service-types": "/app-users-service-types/static-1.4815",
  "mini-checkout-client": "/mini-checkout-client/static-1.26473",
  "onboarding-utils": "/onboarding-utils/static-1.5215",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1975",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28095",
  "edison-service-client-types": "/edison-service-client-types/static-1.255",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3044",
  "crm_data": "/crm_data/static-4.91455",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45584",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15292",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18664",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18123",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9958",
  "crm-fe-perf": "/crm-fe-perf/static-1.22767",
  "directed-graph": "/directed-graph/static-1.802",
  "event-emitter": "/event-emitter/static-1.810",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "calling-error-reporting": "/calling-error-reporting/static-1.31169",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10902",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6404",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.429",
  "commerce-permissions": "/commerce-permissions/static-1.626",
  "products-iframe-lib": "/products-iframe-lib/static-1.7506",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10013",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5410",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9714",
  "policy-lib": "/policy-lib/static-1.6641",
  "react-tinymce": "/react-tinymce/static-1.54799",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9777",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53925",
  "tinymce-plugins": "/tinymce-plugins/static-1.57039",
  "tinymce-themes": "/tinymce-themes/static-1.55895",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1490",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6444",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11704",
  "content-media-compositions": "/content-media-compositions/static-2.15711",
  "media-bridge-lib": "/media-bridge-lib/static-1.18676",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5817",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4949",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3531",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21420",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3706",
  "audio-components": "/audio-components/static-1.5700",
  "FileManagerCore": "/FileManagerCore/static-1.38605",
  "FileManagerImages": "/FileManagerImages/static-1.36257",
  "video-components": "/video-components/static-1.12774",
  "crm-export-dialog": "/crm-export-dialog/static-1.6156",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6298",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1486",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2037",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2356",
  "whisper-core-api": "/whisper-core-api/static-1.6160",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14388",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5206",
  "settings-content-modals": "/settings-content-modals/static-1.45640",
  "crm_universal": "/crm_universal/static-1.21756",
  "customer-data-email": "/customer-data-email/static-1.17781",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36691",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39061",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11431",
  "customer-data-content": "/customer-data-content/static-1.26994",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54228",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21032",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17306",
  "project-storage": "/project-storage/static-1.4596",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71403",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5194",
  "utility-belt": "/utility-belt/static-1.2403",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22187",
  "customer-data-rte": "/customer-data-rte/static-1.32600",
  "cv-backend-services": "/cv-backend-services/static-1.1525",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5457",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4977",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37493",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35206",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "hub-http-contrib": "/hub-http-contrib/static-1.2906",
  "interframe": "/interframe/static-3.4625",
  "tinymce-data": "/tinymce-data/static-1.40010",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5076",
  "layout-dnd-components": "/layout-dnd-components/static-1.12163",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11138",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14336",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8954",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4394",
  "video-embed": "/video-embed/static-1.35263",
  "social-insights-client-types": "/social-insights-client-types/static-1.21568",
  "deal-intel-utils": "/deal-intel-utils/static-1.1490",
  "checkout-sdk": "/checkout-sdk/static-3.23316",
  "checkout-service-types": "/checkout-service-types/static-1.3715",
  "company-details-components": "/company-details-components/static-1.6048",
  "payment-method-components": "/payment-method-components/static-1.6755",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.12959",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3349",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3389",
  "access-control-lib": "/access-control-lib/static-1.10301",
  "EmailComponents": "/EmailComponents/static-1.54316",
  "EmailData": "/EmailData/static-1.52993",
  "redux-less": "/redux-less/static-2.9349",
  "sequences-lib": "/sequences-lib/static-1.7794",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10211",
  "products-ui-components": "/products-ui-components/static-1.39541",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80124",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9000",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6830",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54244",
  "commerce-products-api": "/commerce-products-api/static-1.2052",
  "SafeStorage": "/SafeStorage/static-1.4265",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56302",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102081",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7250",
  "draft-content-plugins": "/draft-content-plugins/static-1.27868",
  "ContentData": "/ContentData/static-1.67889",
  "layout-data-lib": "/layout-data-lib/static-1.9463",
  "outpost": "/outpost/static-1.4062",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.778",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3792",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3852",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18321",
  "pricing-pages-api": "/pricing-pages-api/static-1.12824",
  "ContentComponents": "/ContentComponents/static-2.70770",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9336",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1812",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45799",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.661",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18403",
  "automation-ui-types": "/automation-ui-types/static-1.19321",
  "messaging-types-lib": "/messaging-types-lib/static-1.45536",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4368",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7651",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.381",
  "property-description-translator": "/property-description-translator/static-1.3718",
  "FireAlarmUi": "/FireAlarmUi/static-1.4392",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4051",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3519",
  "totals-ui-components": "/totals-ui-components/static-1.23156",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14906",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11874",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33617",
  "demographics-service-types": "/demographics-service-types/static-1.1512",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5237",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7203",
  "data-token-views": "/data-token-views/static-1.16135",
  "forms-utils-lib": "/forms-utils-lib/static-1.12293",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12727",
  "simple-menus-core": "/simple-menus-core/static-1.14905",
  "simple-menus-lib": "/simple-menus-lib/static-1.16422",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4117",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6617",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3396",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2543",
  "ContentEditorUI": "/ContentEditorUI/static-2.76704",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
  "web-interactives-components": "/web-interactives-components/static-1.13511",
  "web-interactives-data": "/web-interactives-data/static-1.13512",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.110",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.280",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.839",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3700",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21257",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20720",
  "data-studio-ubb": "/data-studio-ubb/static-1.2282",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26590",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57300",
  "content-management-data-lib": "/content-management-data-lib/static-1.5192",
  "copilot-plugins": "/copilot-plugins/static-1.10671",
  "cta-picker": "/cta-picker/static-1.36000",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2617",
  "editor-components": "/editor-components/static-1.13023",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8204",
  "error-messaging-js": "/error-messaging-js/static-1.5053",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85445",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.61",
  "redux-request-state": "/redux-request-state/static-1.10509",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1614",
  "smart-content-core": "/smart-content-core/static-1.42022",
  "smart-content-lib": "/smart-content-lib/static-1.42675",
  "social-composer-lib": "/social-composer-lib/static-1.58391",
  "structured-content-lib": "/structured-content-lib/static-1.24781",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52850",
  "tinymce-copilot": "/tinymce-copilot/static-1.15993",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7678",
  "automation-ui-routing": "/automation-ui-routing/static-1.20678",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5529",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41809",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3018",
  "reporting-enablement": "/reporting-enablement/static-1.22306",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20592",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2097",
  "forms-ai-lib": "/forms-ai-lib/static-1.4096",
  "codemirror-dlb": "/codemirror-dlb/static-1.58263",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6290",
  "report-customization-components": "/report-customization-components/static-1.12695",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12478",
  "html-to-image": "/html-to-image/static-1.50",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1253"
}
};
